import React from "react";
import { styled } from "@mui/material/styles";
import {
  Card,
  CardActions,
  IconButton,
  Collapse,
  Typography,
  CardContent,
  Avatar,
  Accordion,
  AccordionSummary,
  AccordionDetails,
} from "@mui/material";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

const list = [
  {
    ques: "เมนู My GPF & My GPF Twins เปลี่ยนชื่อเป็นอะไร?",
    ans: [
      "เมนู My GPF & My GPF Twins เวอร์ชันล่าสุด เปลี่ยนชื่อเป็นเมนู My Digital Twins โดยให้บริการบน My GPF Application เช่นเดิม",
    ],
  },
  {
    ques: "เมนู My Digital Twins คืออะไร?",
    ans: [
      "เมนู Digital Twins เป็นเมนูที่จะช่วยให้สมาชิกรู้เป้าหมายทางการเงิน ณ เกษียณ (MLS) สามารถวางแผนเกษียณมีสุขได้อย่างมั่นใจ โดยเมนูนี้มีจุดเด่น ดังนี้",
      "- ประมาณการรายได้ ณ เกษียณได้แม่นยำและครบถ้วนยิ่งขึ้น ประกอบด้วย เงินก้อน กบข. และ เงินบำนาญจากรัฐ",
      "- ทดลองปรับอัตราออมเพิ่มและแผนการลงทุนโดยไม่กระทบยอดเงินจริงของสมาชิก ด้วยการสร้าง My Twin 1 \"ลองเลือกเองได้ตามใจ\"",
      "- เลือกดูทางเลือกตามระดับเป้าหมายทางการเงิน ณ เกษียณ (MLS) ใน My Twin 2 \"กบข. ออกแบบให้ตามเป้าหมายคุณ\"",
      "- เปรียบเทียบประมาณการรายได้ ณ เกษียณ (My GPF  My Twin 1 และ My Twin 2) กับ ระดับเป้าหมายทางการเงิน ณ เกษียณ (MLS) อย่างสม่ำเสมอเพื่อใช้พิจารณาวางแผนเกษียณของสมาชิกได้",
    ],
  },
  {
    ques: "ประมาณการรายได้ ณ เกษียณ ประกอบด้วยอะไรบ้าง?",
    ans: [
      "ประมาณการรายได้ ณ เกษียณ ประกอบด้วย 2 ส่วน คือ 1) เงินก้อน กบข. ที่คาดว่าจะได้รับ ซึ่งคำนวณจากข้อมูลสมมติฐานที่สมาชิกกรอกเอง ได้แก่ อัตราขึ้นเงินเดือน เพดานเงินเดือน อายุหรือปีที่คาดว่าจะเกษียณ และอายุขัยที่คาดการณ์ โดยคำนวณร่วมกับอัตราการออมและแผนการลงทุนปัจจุบันของสมาชิก  2) เงินบำนาญจากรัฐที่คาดว่าสมาชิกจะได้รับจากกรมบัญชีกลาง ซึ่งคำนวณโดยตั้งต้นจากอัตราเงินเดือนปัจจุบันของสมาชิก และประมาณการข้อมูลในอนาคตจากสมมติฐานที่สมาชิกกรอก เช่น อัตราขึ้นเงินเดือน อัตราเงินเดือนสูงสุด (มีสมมติฐานขยายอัตราเงินเดือนสูงสุด 5% ทุก 5 ปี) เป็นต้น จากนั้นคำนวณเงินบำนาญโดยใช้หลักเกณฑ์การคำนวณเงินบำนาญตามที่กำหนดในมาตรา 63 ของ พรบ. กบข. ปี 2539 ทั้งนี้ เวลาราชการสำหรับคำนวณเงินบำนาญไม่รวมถึงเวลาราชการทวีคูณหรือเวลาราชการที่ต้องถูกหักออกเนื่องจากการลาไปศึกษา ฝึกอบรม ดูงาน หรือปฏิบัติการวิจัย หรือไปสมัครรับเลือกตั้ง หรือด้วยเหตุอื่นใด โดยการประมาณการเงินบำนาญเป็นเงินก้อน มาจากยอดรวมของประมาณการเงินบำนาญรายเดือนที่คาดว่าสมาชิกจะได้รับจนถึงอายุขัยที่สมาชิกระบุ แล้วคิดลดเป็นมูลค่าปัจจุบัน ณ เกษียณด้วยอัตราผลตอบแทนหลังเกษียณ 2.60% ต่อปี",
    ],
  },
  {
    ques: "ในเมนู My Digital Twins มีอะไรบ้าง?",
    ans: [
      "เมนู My Digital Twins ประกอบด้วย 8 ส่วนหลัก ๆ  ดังนี้",
      "1) กรอกข้อมูลสมมติฐานของสมาชิกเอง ได้แก่ อัตราขึ้นเงินเดือน เพดานเงินเดือน  อายุหรือปีที่คาดว่าจะเกษียณ และ อายุขัยที่คาดการณ์",
      "2) กรอกข้อมูลหนี้สินที่จะมี ณ เกษียณ (ถ้ามี) และเปรียบเทียบสัดส่วนของหนี้สินกับประมาณการรายได้ ณ เกษียณ",
      "3) My GPF เป็นการคำนวณประมาณการรายได้ ณ เกษียณ ประกอบด้วย เงินก้อน กบข. และ เงินบำนาญจากรัฐ",
      "4) My Twin 1  \"ลองเลือกเองได้ตามใจ\" สมาชิกสามารถทดลองปรับอัตราออมเพิ่ม และ เลือกแผนการลงทุนโดยไม่กระทบยอดเงินจริง สร้างได้สูงสุด 3 แบบ",
      "5) เลือกยอดเงินเป้าหมายตามระดับเป้าหมายทางการเงิน ณ เกษียณ (MLS) ของตนเอง เพื่อให้ กบข. ออกแบบทางเลือกให้",
      "6) My Twin 2  \"กบข. ออกแบบให้ตามเป้าหมายคุณ\" สมาชิกสามารถเลือกดูทางเลือกที่ กบข. ออกแบบให้ตามเป้าหมายทางการเงิน ณ เกษียณ (MLS) โดยสร้างได้สูงสุด 3 แบบ",
      "7) เปรียบเทียบประมาณรายได้ ณ เกษียณ (My GPF My Twin 1 My Twin 2) กับระดับเป้าหมายทางการเงิน ณ เกษียณ (MLS) 3 ระดับ ให้สมาชิกได้เห็นภาพ ณ เกษียณชัดเจนยิ่งขึ้น",
      "8) เปรียบเทียบกับสมาชิกอื่นที่มีลักษณะใกล้เคียงกับสมาชิก เช่น ปีที่เริ่มเป็นสมาชิก ปีที่จะเกษียณอายุ ช่วงอัตราเงินเดือน เป็นต้น",
    ],
  },
  {
    ques: "เป้าหมายทางการเงิน ณ เกษียณ (MLS) คืออะไร?",
    ans: [
      "เป้าหมายทางการเงิน ณ เกษียณ หรือ MLS (Minimum Lump Sum) หมายถึง จำนวนเงินที่ “ควรจะมี” ณ เกษียณ เพื่อให้สามารถใช้จ่ายได้อย่างเพียงพอตลอดชีวิตหลังเกษียณโดย กบข. ประมาณการเป้าหมายทางการเงิน ณ เกษียณ ใช้ข้อมูลต่อไปนี้ 1) การสำรวจค่าใช้จ่ายของสมาชิก กบข. ที่เกษียณอายุราชการตามการศึกษาความเพียงพอ ณ เกษียณของสมาชิกโดยยังไม่รวมภาระหนี้สินและค่าเช่าที่อยู่อาศัย 2) อายุขัยที่คาดการณ์ และ 3) การคาดการณ์ค่าใช้จ่ายที่จะเพิ่มขึ้นในแต่ละปี",
      "ทั้งนี้ เป้าหมายทางการเงิน ณ เกษียณ มี “ระดับ” ต่างกันตามคุณภาพชีวิตที่คาดหวัง ดังนี้ 1) ระดับดีมาก (P90) หรือ ชีวิตที่มีอิสระใช้จ่ายไร้กังวล 2) ระดับดี (P75) หรือ ชีวิตที่มีความสุขเพิ่มขึ้นอีกระดับ  และ 3) ระดับพื้นฐานทั่วไป (P50) หรือ ชีวิตที่เรียบง่าย โดยเป้าหมายทางการเงิน ณ เกษียณ ในระดับดี (P75) คือ เป้าหมายมาตรฐานที่ กบข. แนะนำให้สมาชิกตั้งไว้เพื่อให้มีคุณภาพชีวิตที่ “ดีพอ” ณ เกษียณ",
    ],
  },
  {
    ques: "My Twin 1 ต่างกับ My Twin 2 อย่างไร?",
    ans: [
      "My Twin 1 \"ลองเลือกเองได้ตามใจ\" คือ การทดลองปรับอัตราออมเพิ่มและเลือกแผนการลงทุนเพื่อประมาณการรายได้ ณ เกษียณ ไม่กระทบยอดเงินจริง สร้าง My Twin 1 ได้สูงสุด 3 แบบ",
      "My Twin 2  \"กบข. ออกแบบให้ตามเป้าหมายคุณ\"  คือ กบข. ออกแบบทางเลือกประมาณการรายได้ ณ เกษียณจากเป้าหมายทางการเงิน ณ เกษียณ (MLS) ให้สมาชิกสร้าง My Twin 2 ได้สูงสุด 3 แบบ",
    ],
  },
  {
    ques: "ถ้าทดลองปรับอัตราออมเพิ่ม และ แผนการลงทุนใน My Twin 1 จะกระทบกับยอดเงินในปัจจุบันหรือไม่?",
    ans: [
      "ไม่กระทบกับยอดเงินจริงของสมาชิก เป็นเพียงการทดลองปรับอัตราออมเพิ่มและทดลองเลือกแผนการลงทุนเพื่อดูประมาณการรายได้ ณ เกษียณเท่านั้น",
    ],
  },
  {
    ques: "My Twin 2 กบข. ออกแบบให้สมาชิก โดยดูจากอะไร?",
    ans: [
      "กบข. ออกแบบ My Twin 2 ให้สมาชิกแต่ละคน โดยดูจากเป้าหมายทางการเงิน ณ เกษียณ (MLS) ของสมาชิก แล้วนำมาคำนวณหาทางเลือกในอัตราการออมและแผนการลงทุนต่าง ๆ ให้กับสมาชิก"
    ],
  },
  {
    ques: "ถ้าเลือกทางเลือกตามที่ กบข. ออกแบบให้ใน My Twin 2 จะกระทบกับยอดเงินหรือแผนการลงทุนในปัจจุบันหรือไม่?",
    ans: [
      "ไม่กระทบกับยอดเงินจริงหรือแผนการลงทุนของสมาชิก เป็นเพียงการเลือกดูทางเลือกตามเป้าหมายทางการเงิน ณ เกษียณ (MLS) ของสมาชิก เพื่อดูประมาณการรายได้ ณ เกษียณเท่านั้น",
    ],
  },
  {
    ques: "เป้าหมายทางการเงิน ณ เกษียณ (MLS) ที่ตั้งไว้สามารถปรับเปลี่ยนได้หรือไม่?",
    ans: [
      "สมาชิกสามารถปรับเปลี่ยนยอดเงินเป้าหมายตามระดับเป้าหมายทางการเงิน ณ เกษียณ (MLS) ได้ โดยกดที่ My Twin 2 จากนั้นกดปุ่มรูปดินสอที่หัวข้อ \"เป้าหมาย ณ เกษียณที่คุณระบุ x.xx ล้านบาท\" เพื่อปรับเปลี่ยนข้อมูล ",
    ],
  },
  {
    ques: "ประมาณการรายได้ ณ เกษียณที่แอปคำนวณให้ จะได้ตอนเกษียณตามนี้เลยหรือไม่?",
    ans: [
      "ยอดเงินที่แสดงเป็นยอดเงินประมาณการตามสมมติฐานซึ่งอาจจะไม่ใช่ยอดเงินที่สมาชิกได้รับจริง ณ เกษียณ ซึ่งการลงทุนย่อมมีความเสี่ยงและผลตอบแทนจากการลงทุนอาจมีความผันผวนขึ้นอยู่กับปัจจัยทางเศรษฐกิจ สถานการณ์การลงทุน และข้อมูลที่ใช้ในการคํานวณในแต่ละช่วงเวลา ดังนั้น กบข. ไม่ได้รับประกันว่า ประมาณการเงินที่คาดว่าสมาชิกจะได้รับจาก กบข.* และ ประมาณการเงินบำนาญที่คาดว่าสมาชิกจะได้รับจากกรมบัญชีกลาง** ตามการประมวลผลและแสดงในแอปพลิเคชันนี้จะเป็นจำนวนเงินที่สมาชิกจะได้รับจริงเมื่อสมาชิกออกจากราชการ",
      "*จำนวนเงินที่สมาชิกจะได้รับจาก กบข. จริง ขึ้นอยู่กับผลตอบแทนที่เกิดขึ้นจากแผนการลงทุนที่สมาชิกเลือกลงทุน จำนวนเงินที่สมาชิกนำส่ง และวันที่ที่ขอรับเงินจาก กบข.",
      "**กรณีสมาชิกต้องการสอบถามข้อมูลเพิ่มเติมเกี่ยวกับเงินบำนาญ โปรดติดต่อ กรมบัญชีกลาง โทร. 0-2270-6400 หรือสํานักงานคลังเขตของกรมบัญชีกลางทุกแห่ง",
    ],
  },
  {
    ques: "ประมาณการรายได้ ณ เกษียณที่เปรียบเทียบกับเพื่อนสมาชิกใช้เกณฑ์อะไรบ้าง?",
    ans: [
      "คำนวณจากข้อมูลสมาชิกที่บรรจุเข้ารับราชการปีเดียวกัน จะเกษียณอายุปีเดียวกัน มีเงินเดือนใกล้เคียงกับสมาชิก และ อายุขัยคาดการณ์ที่ 80 ปี"
    ],
  },
  {
    ques: "เมนู My Digital Twins เลือกอายุที่จะเกษียณเองได้หรือไม่?",
    ans: [
      "สมาชิกสามารถเลือกอายุเกษียณ หรือระบุเดือนปีที่จะเกษียณได้ด้วยตนเอง"
    ],
  },
  {
    ques: "ทำไมต้องกรอกหนี้สิน?",
    ans: [
      "หนี้สินเป็นปัจจัยสำคัญที่จะกำหนดว่า ประมาณการรายได้ที่สมาชิกจะได้รับ ณ เกษียณนั้นเพียงพอสำหรับใช้หนี้สินและสำหรับใช้ชีวิตหลังเกษียณในแบบที่ต้องการหรือไม่  ดังนั้น สมาชิกจึงควรรู้สัดส่วนหนี้สินของตนเองให้ชัดเจนว่า มีหนี้สินคิดเป็นกี่เปอร์เซนต์เมื่อเทียบกับประมาณการรายได้ ณ เกษียณที่จะได้รับในอนาคต"
    ],
  },
  {
    ques: "เข้าใช้งานเมนู My Digital Twins ได้ที่ไหน?",
    ans: [
      "เมนู My Digital Twins เข้าใช้งานได้ที่ My GPF Application"
    ],
  },
  {
    ques: "ถ้าเคยสร้าง My GPF หรือ My Twin 1 หรือ My Twin 2 แล้ว สามารถสร้างใหม่ได้หรือไม่?",
    ans: [
      "สมาชิกสามารถสร้าง My GPF  My Twin 1 และ My Twin 2 ได้ใหม่อีกครั้งเพื่อทบทวนและพิจารณาวางแผนเกษียณได้แม่นยำยิ่งขึ้น"
    ],
  },
  {
    ques: "My Digital Twins มีการคำนวณประมาณรวมเงินบำนาญหรือไม่?",
    ans: [
      "My Digital Twins เวอร์ชันล่าสุด มีการคำนวณประมาณรายได้ ณ เกษียณ รวมทั้งเงินก้อน กบข. และเงินบำนาญจากรัฐด้วย เพื่อให้สมาชิกสามารถใช้วางแผนเกษียณได้อย่างมั่นใจ ทั้งนี้ ในส่วนของเงินบำนาญจากรัฐนั้น คำนวณโดยตั้งต้นจากอัตราเงินเดือนปัจจุบันของสมาชิก และประมาณการข้อมูลในอนาคตจากสมมติฐานที่สมาชิกกรอก เช่น อัตราขึ้นเงินเดือน อัตราเงินเดือนสูงสุด (มีสมมติฐานขยายอัตราเงินเดือนสูงสุด 5% ทุก 5 ปี) เป็นต้น จากนั้นคำนวณเงินบำนาญโดยใช้หลักเกณฑ์การคำนวณเงินบำนาญตามที่กำหนดในมาตรา 63 ของ พรบ. กบข. ปี 2539 ทั้งนี้เวลาราชการสำหรับคำนวณเงินบำนาญไม่รวมถึงเวลาราชการทวีคูณหรือเวลาราชการที่ต้องถูกหักออกเนื่องจากการลาไปศึกษา ฝึกอบรม ดูงาน หรือปฏิบัติการวิจัย หรือไปสมัครรับเลือกตั้ง หรือด้วยเหตุอื่นใด ซึ่งการประมาณการเงินบำนาญเป็นเงินก้อน มาจากยอดรวมของประมาณการเงินบำนาญรายเดือนที่คาดว่าสมาชิกจะได้รับจนถึงอายุขัยที่สมาชิกระบุ แล้วคิดลดเป็นมูลค่าปัจจุบัน ณ เกษียณด้วยอัตราผลตอบแทนหลังเกษียณ 2.60% ต่อปี",
      "อย่างไรก็ตาม กบข. ไม่ได้รับประกันว่า ประมาณการเงินบำนาญที่คาดว่าสมาชิกจะได้รับจากกรมบัญชีกลาง** ตามการประมวลผลและแสดงในแอปพลิเคชันนี้จะเป็นจำนวนเงินที่สมาชิกจะได้รับจริงเมื่อสมาชิกออกจากราชการ",
      "**กรณีสมาชิกต้องการสอบถามข้อมูลเพิ่มเติมเกี่ยวกับเงินบำนาญ โปรดติดต่อ กรมบัญชีกลาง โทร. 0-2270-6400 หรือสํานักงานคลังเขตของกรมบัญชีกลางทุกแห่ง",
    ],
  },
  {
    ques: "อัตราขึ้นเงินเดือน อัตราเงินเดือนสูงสุด คืออะไร?",
    ans: [
      "อัตราขึ้นเงินเดือน คือ การปรับเงินเดือนของแต่ละตำแหน่งให้สูงขึ้นจากเดิม โดยคิดเป็นตัวเลขเปอร์เซนต์ (%) ของเงินเดือนที่จะปรับขึ้นตามโครงสร้างเงินเดือนของกรมบัญชีกลาง โดยส่วนใหญ่คาดว่าจะมีการปรับอัตราขึ้นเงินเดือนในช่วงเดือนเมษายน และ เดือนตุลาคมของทุกปี",
      "อัตราเงินเดือนสูงสุด หรือ เพดานเงินเดือน คือ ขั้นสูงสุดของเงินเดือนที่แต่ละตำแหน่งจะไปถึงได้ในอนาคต หรือ เงินเดือนสุดท้ายก่อนที่สมาชิกจะเกษียณอายุ (ไม่ใช่เงินเดือน ณ ปัจจุบันของสมาชิก)",
    ],
  },
  {
    ques: "อายุขัยที่คาดการณ์ คืออะไร?",
    ans: [
      "อายุขัยที่คาดการณ์ เป็นข้อมูลสำหรับใช้คำนวณประมาณการเงินก้อนบำนาญ และค่าใช้จ่ายหลังเกษียณ เพื่อเป็นส่วนหนึ่งของการประเมินว่าสมาชิกจะบรรลุเป้าหมายทางการเงิน ณ เกษียณ (MLS) ระดับใด",
    ],
  },
  {
    ques: "ทำไมถึงกรอกอายุหรือปีที่จะเกษียณน้อยกว่า 50 ปีไม่ได้?",
    ans: [
      "เนื่องจากสมาชิกส่วนใหญ่ที่เกษียณอายุมีสิทธิ์และเลือกรับบำนาญนั้นจะมีอายุ 50 ปีขึ้นไป ประกอบกับ การคำนวณประมาณการเงิน กบข. จะคำนวณยอดเงินรวมทุกประเภททั้งเงินสะสม เงินออมเพิ่ม (ถ้ามี) เงินสมทบ เงินประเดิม (ถ้ามี) และเงินชดเชย ซึ่งในส่วนเงินประเดิม (ถ้ามี) และเงินชดเชยนั้นสมาชิกจะได้รับเมื่อมีสิทธิ์และเลือกรับบำนาญเท่านั้น ดังนั้น เพื่อการคำนวณประมาณการรายได้ ณ เกษียณที่ชัดเจนยิ่งขึ้น กบข. จึงใช้ข้อมูลดังกล่าวในการกำหนดช่วงอายุเกษียณที่สมาชิกสามารถกรอกได้เองไว้ที่ 50 ปีขึ้นไป",
    ],
  },
];

const Faq = ({ width, appbarHeight }) => {
  return (
    <div style={{ paddingTop: 150 }}>
      <h2 className="text-lighting text-center mb-4">คำถามที่พบบ่อย</h2>
      <div className="container">
        {list.map((faqItem, itemIndex) => (
          <Accordion defaultExpanded={itemIndex == 0 ? true : false}>
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel1a-content"
              id="panel1a-header"
            >
              <Avatar sx={{ width: 30, height: 30 }} className="bg-lighting">
                Q
              </Avatar>
              <Typography variant="h6" className="pl-2 colorbase">
                {faqItem.ques}
              </Typography>
            </AccordionSummary>
            <AccordionDetails>
              <CardContent className="row p-3">
                <div className="col-md">
                  {faqItem.ans.map((ansItem, i) => (
                    <Typography key={"anslist" + i} paragraph>
                      {ansItem}
                    </Typography>
                  ))}
                </div>
                {faqItem.img != undefined &&
                  faqItem.img.length <= 2 &&
                  faqItem.img.map((imgItem, i) => (
                    <div
                      key={"img" + i}
                      className={
                        "col-md-" + (faqItem.img.length == 1 ? "5" : "3")
                      }
                    >
                      {imgItem.text != undefined && (
                        <h5 className="colorbase text-center">
                          {imgItem.text}
                        </h5>
                      )}
                      <img src={imgItem.src} width="100%" />
                    </div>
                  ))}
                {faqItem.img != undefined && faqItem.img.length === 3 && (
                  <>
                    <div className={"col-md-3 pl-0 pr-0"}>
                      <img src={faqItem.img[0].src} width="100%" />
                    </div>
                    <div
                      className={
                        "col-md-auto pl-0 pr-0" +
                        (width < 800 ? " text-center mb-3 pt-2" : " pl-5 pt-5")
                      }
                    >
                      <img
                        src={faqItem.img[1].src}
                        width={width < 750 ? "10%" : "40%"}
                        style={{
                          transform:
                            width < 750 ? "rotate(90deg)" : "rotate(0deg)",
                        }}
                      />
                    </div>
                    <div className={"col-md-3 pl-0 pr-0"}>
                      <img src={faqItem.img[2].src} width="100%" />
                    </div>
                  </>
                )}
              </CardContent>
            </AccordionDetails>
          </Accordion>
        ))}
      </div>
    </div>
  );
};

export default Faq;
